import './Loader.scss'

const Loader = () => {
    return (
        <div className="loader-outer">
            <div className="loader-inner">
                <div className="load8">
                    <div className="loader"></div>
                </div>
            </div>
        </div>
    )
}

export default Loader
